import { render, staticRenderFns } from "./NavMenu.vue?vue&type=template&id=6813af3a&scoped=true&"
import script from "./NavMenu.vue?vue&type=script&lang=js&"
export * from "./NavMenu.vue?vue&type=script&lang=js&"
import style0 from "./NavMenu.vue?vue&type=style&index=0&id=6813af3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6813af3a",
  null
  
)

export default component.exports